<template>
  <v-container class="h-screen flex items-center justify-center bg-gray-50/50" fluid>
    <v-row justify="center" align="center" class="text-center">
      <v-col cols="12" md="8" lg="6">
        <div class="mb-8 flex justify-center">
          <div class="bg-red-50 p-8 rounded-full ring-8 ring-red-50/50">
            <v-icon :icon="mdiShieldLockOutline" size="100" class="text-red-500" />
          </div>
        </div>

        <h1 class="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Acesso Não Autorizado</h1>

        <p class="text-gray-500 text-lg mb-10 leading-relaxed max-w-lg mx-auto">
          Você não possui permissão para acessar esta página.
          <br class="hidden sm:block" />
          Se você acredita que isso é um erro, verifique suas credenciais ou entre em contato com o
          administrador do sistema.
        </p>

        <div class="flex flex-col sm:flex-row gap-4 justify-center items-center w-full">
          <v-btn
            color="primary"
            class="w-full sm:w-auto h-[56px] font-bold capitalize px-8 text-white"
            elevation="0"
            @click="goToLogin"
          >
            Voltar para o login
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { mdiShieldLockOutline } from '@mdi/js'
import PATHS from '@/router/paths'

const router = useRouter()

const goToLogin = () => {
  router.push(PATHS.SIGNIN)
}
</script>

<style scoped></style>
